import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'

function resetScrollPosition() {
  if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
    window.scrollTo({top: 0, left: 0, behavior: 'auto'})
  }

  if (typeof document === 'undefined') return

  if (document.documentElement) {
    document.documentElement.scrollTop = 0
    document.documentElement.scrollLeft = 0
  }

  if (document.body) {
    document.body.scrollTop = 0
    document.body.scrollLeft = 0
  }

  const appScrollRoot = document.querySelector('[data-app-scroll-root="true"]')
  if (appScrollRoot) {
    appScrollRoot.scrollTop = 0
    appScrollRoot.scrollLeft = 0
  }
}

export default function ScrollToTop() {
  const location = useLocation()

  useEffect(() => {
    if (typeof window !== 'undefined' && window.history?.scrollRestoration) {
      window.history.scrollRestoration = 'manual'
    }

    resetScrollPosition()

    let animationFrameId = null
    let timeoutId = null

    if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
      animationFrameId = window.requestAnimationFrame(() => {
        resetScrollPosition()
      })
    }

    if (typeof window !== 'undefined' && typeof window.setTimeout === 'function') {
      timeoutId = window.setTimeout(() => {
        resetScrollPosition()
      }, 0)
    }

    return () => {
      if (typeof window === 'undefined') return
      if (animationFrameId !== null && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(animationFrameId)
      }
      if (timeoutId !== null && typeof window.clearTimeout === 'function') {
        window.clearTimeout(timeoutId)
      }
    }
  }, [location.key, location.pathname, location.search, location.hash])

  return null
}
